import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, ReactNode, useState } from 'react';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import {
    InstructionList,
    InstructionListElement,
    InstructionText,
    InstructionWrapper,
    SecondHandMachinesAccordionBox,
    SecondHandMachinesAccordionButton,
    SecondHandMachinesAccordionContent,
} from './SecondHandMachinesAccordionStyle';
import SecondHandMachinesAccordionTable from './SecondHandMachinesAccordionTable/SecondHandMachinesAccordionTable';

interface SecondHandMachinesAccordionProps {
    title: string | null;
    tableData?: any;
    unSortableTableData?: any;
    instructionText?: string;
    instructionListElements?: Array<string>;
}

const SecondHandMachinesAccordion: FC<SecondHandMachinesAccordionProps> = ({
    title,
    tableData,
    unSortableTableData,
    instructionText,
    instructionListElements,
}) => {
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState(false);

    const displayAccordionContent = (): ReactNode => {
        if (tableData) {
            return <SecondHandMachinesAccordionTable tableData={tableData} />;
        } else if (unSortableTableData) {
            return <SecondHandMachinesAccordionTable unSortableTableData={unSortableTableData} />;
        } else {
            return (
                <InstructionWrapper>
                    <InstructionText dangerouslySetInnerHTML={{ __html: instructionText }}></InstructionText>
                    <InstructionList>
                        {instructionListElements?.map((item: string, index: number) => (
                            <InstructionListElement key={item + index}>{item}</InstructionListElement>
                        ))}
                    </InstructionList>
                </InstructionWrapper>
            );
        }
    };

    return (
        <SecondHandMachinesAccordionBox>
            <SecondHandMachinesAccordionButton onClick={() => setIsActive((isActive) => !isActive)}>
                {isActive ? <IoIosArrowDown /> : <IoIosArrowForward />}
                <span>{t(title)}</span>
            </SecondHandMachinesAccordionButton>
            <SecondHandMachinesAccordionContent isActive={isActive}>
                {displayAccordionContent()}
            </SecondHandMachinesAccordionContent>
        </SecondHandMachinesAccordionBox>
    );
};

export default SecondHandMachinesAccordion;
